import { render, staticRenderFns } from "./Carts.vue?vue&type=template&id=0d54ddb2&scoped=true&"
import script from "./Carts.vue?vue&type=script&lang=js&"
export * from "./Carts.vue?vue&type=script&lang=js&"
import style0 from "./Carts.vue?vue&type=style&index=0&id=0d54ddb2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d54ddb2",
  null
  
)

export default component.exports